module.exports = __webpack_public_path__ + "images/emoji/u7121.316aa2d9c457a8e50159.png";